import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=7ab40a38&"
import script from "./MainContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MainContent.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab40a38')) {
      api.createRecord('7ab40a38', component.options)
    } else {
      api.reload('7ab40a38', component.options)
    }
    module.hot.accept("./MainContent.vue?vue&type=template&id=7ab40a38&", function () {
      api.rerender('7ab40a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/ethical-commission/index/components/MainContent/MainContent.vue"
export default component.exports